import type { ThemeOptions } from '@mui/material/styles';
import { baseline } from './baseline';

export const components: ThemeOptions['components'] = {
  // Everything the browser draws itself — scrollbars, spinners, autofill, focus rings.
  MuiCssBaseline: {
    styleOverrides: (theme) => baseline(theme),
  },
  MuiButton: {
    defaultProps: { disableElevation: true },
    styleOverrides: { root: { textTransform: 'none' } },
  },
  MuiCard: {
    styleOverrides: { root: { overflow: 'hidden' } },
  },
  MuiTextField: {
    defaultProps: { size: 'small' },
  },
  MuiTabs: {
    // Set here rather than at each use, because the ones that overflowed were exactly the
    // ones nobody thought to mark. A run has five tabs and a 360px screen fits three: the
    // rest were clipped with no way to reach them, and the page looked like it had lost
    // half its content. Scrolling costs nothing when everything already fits.
    defaultProps: {
      variant: 'scrollable',
      scrollButtons: 'auto',
      // Without this the arrows are hidden on touch devices, leaving a strip that can be
      // swiped but gives no sign that it can.
      allowScrollButtonsMobile: true,
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => ({
        backgroundImage: 'none',
        // A dialog that reaches the edges of a phone looks like a page, not a dialog — so it
        // keeps a margin, but a much smaller one. MUI's default 32px costs 64px of a 360px
        // screen, which is where the forms inside started wrapping every label.
        [theme.breakpoints.down('sm')]: {
          margin: 16,
          width: 'calc(100% - 32px)',
          maxWidth: 'calc(100% - 32px)',
          maxHeight: 'calc(100% - 32px)',
        },
      }),
    },
  },
  MuiTooltip: {
    defaultProps: { arrow: true },
  },
};
